import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { tap } from 'rxjs';
import { RoleDTO } from '../models/RoleDTO.model';
import { SimpleRequestDTO } from '../shared/models/SimpleRequest';
import { ModuleByRoleDTO } from '../models/ModuleByRoleDTO.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpService: HttpService) { }

  getRoles() {
    return this.httpService.getRoles().pipe(
      tap((data) => {
      })
    );
  }

  getListRoles() {
    return this.httpService.getListRoles().pipe(
      tap((data) => {
      })
    );
  }

  updateCustomerStatus(role: RoleDTO) {
    return this.httpService.updateRoleStatus(role).pipe(
      tap((data) => {
      })
    );
  }

  createRole(role: RoleDTO) {
    return this.httpService.createRole(role).pipe(
      tap((data) => {
      })
    );
  }

  getRoleById(request: SimpleRequestDTO){
    return this.httpService.getRoleById(request).pipe(
      tap((data) => {
      })
    );
  }

  updateRole(role: RoleDTO){
    return this.httpService.updateRole(role).pipe(
      tap((data) => {
      })
    );
  }

  getModuleByRole(request: SimpleRequestDTO){
    return this.httpService.getModuleByRole(request).pipe(
      tap((data) => {
      })
    );
  }

  updateModuleByRole(request: ModuleByRoleDTO[]){
    return this.httpService.updateModuleByRole(request).pipe(
      tap((data) => {
      })
    );
  }
}
